import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * AuthCallback — handles the post-Google redirect.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 *
 * URL fragment shape: #session_id=<id>
 * We synchronously extract on first render, hand it to the backend
 * `/auth/exchange` endpoint, store the returned session_token, then
 * navigate to the page the user came from (or "/").
 */
const AuthCallback = () => {
  const navigate = useNavigate();
  const { completeLogin } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const session_id = m ? decodeURIComponent(m[1]) : null;
    const returnTo = sessionStorage.getItem("archive_post_login_path") || "/";
    sessionStorage.removeItem("archive_post_login_path");

    if (!session_id) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        const res = await axios.post(`${API}/auth/exchange`, { session_id });
        const { session_token, user } = res.data;
        completeLogin(session_token, user);
        navigate(returnTo, { replace: true });
      } catch {
        navigate("/", { replace: true });
      }
    })();
  }, [completeLogin, navigate]);

  return (
    <div
      data-testid="auth-callback"
      className="min-h-[50vh] flex items-center justify-center"
    >
      <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#D92D20]">
        // verifying credentials…
      </div>
    </div>
  );
};

export default AuthCallback;
